<mat-tab-group
  #tabGroup
  (selectedTabChange)="tabChanged($event)"
  [(selectedIndex)]="selectedIndex"
  >
  @if (tabs['admin']) {
    <mat-tab [label]="'admin'" class="admin">
      <ng-template mat-tab-label>Dashboard</ng-template>
      <header>
        <h1>Dashboard</h1>
      </header>
      @if (currentTab.value == 'admin') {
        <section class="admin-dashboard">
          @if (tabs['event-admin']) {
            <sold-out-dashlet></sold-out-dashlet>
          }
          @if (tabs['event-admin']) {
            <event-ending-dashlet></event-ending-dashlet>
          }
          @if (tabs['user-admin']) {
            <new-users-dashlet></new-users-dashlet>
          }
          @if (tabs['listing-admin']) {
            <new-pages-dashlet></new-pages-dashlet>
          }
          @if (tabs['event-admin']) {
            <not-sold-ballot-dashlet
            ></not-sold-ballot-dashlet>
          }
        </section>
      }
    </mat-tab>
  }
  @if (tabs['reporting']) {
    <mat-tab [label]="'reporting'" class="reporting">
      <ng-template mat-tab-label>Reporting</ng-template>
      @if (currentTab.value == 'reporting') {
        <reporting-dashboard></reporting-dashboard>
      }
    </mat-tab>
  }
  @if (tabs['listing-admin']) {
    <mat-tab
      [label]="'listing-admin'"
      class="listing-admin"
      >
      <ng-template mat-tab-label>Pages</ng-template>
      @if (currentTab.value == 'listing-admin') {
        <listing-admin-dashboard
          [currentTab]="currentTab"
        ></listing-admin-dashboard>
      }
    </mat-tab>
  }
  @if (tabs['event-admin']) {
    <mat-tab
      [label]="'event-admin'"
      class="event-admin"
      >
      <ng-template mat-tab-label>Events</ng-template>
      @if (currentTab.value == 'event-admin') {
        <event-admin-dashboard
          [currentTab]="currentTab"
        ></event-admin-dashboard>
      }
    </mat-tab>
  }
  @if (tabs['categories-admin']) {
    <mat-tab
      [label]="'categories-admin'"
      class="categories-admin"
      >
      <ng-template mat-tab-label>Categories</ng-template>
      @if (currentTab.value == 'categories-admin') {
        <categories-dashboard
          (next)="setTab($event)"
          (ballotView)="setTab($event)"
          [currentTab]="currentTab"
        ></categories-dashboard>
      }
    </mat-tab>
  }
  @if (tabs['organisation-admin']) {
    <mat-tab
      [label]="'organisation-admin'"
      class="organisation-admin"
      >
      <ng-template mat-tab-label>Organisations</ng-template>
      @if (currentTab.value == 'organisation-admin') {
        <organisation-admin-dashboard
          [currentTab]="currentTab"
        ></organisation-admin-dashboard>
      }
    </mat-tab>
  }
  @if (tabs['user-admin']) {
    <mat-tab [label]="'user-admin'" class="user-admin">
      <ng-template mat-tab-label>Users</ng-template>
      @if (currentTab.value == 'user-admin') {
        <user-admin-dashboard
          [currentTab]="currentTab"
        ></user-admin-dashboard>
      }
    </mat-tab>
  }
  @if (tabs['retired-user-admin']) {
    <mat-tab
      [label]="'retired-user-admin'"
      class="retired-user-admin"
      >
      <ng-template mat-tab-label>Retired Users</ng-template>
      @if (currentTab.value == 'retired-user-admin') {
        <retired-user-admin-dashboard
          [currentTab]="currentTab"
        ></retired-user-admin-dashboard>
      }
    </mat-tab>
  }

  @if (tabs['user-admin']) {
    <mat-tab
      [label]="'all-admin-users'"
      class="all-admin-users"
      >
      <ng-template mat-tab-label>All Admin Users</ng-template>
      @if (currentTab.value == 'all-admin-users') {
        <all-admin-users-dashboard
          [currentTab]="currentTab"
        ></all-admin-users-dashboard>
      }
    </mat-tab>
  }

  @if (tabs['finance-admin']) {
    <mat-tab
      [label]="'finance-admin'"
      class="finance-admin"
      >
      <ng-template mat-tab-label>Finance</ng-template>
      @if (currentTab.value == 'finance-admin') {
        <finance-admin-dashboard
          [currentTab]="currentTab"
        ></finance-admin-dashboard>
      }
    </mat-tab>
  }
  @if (tabs['local-offers-admin']) {
    <mat-tab
      [label]="'local-offers-admin'"
      class="local-offers"
      >
      <ng-template mat-tab-label>Local Offers</ng-template>
      @if (currentTab.value == 'local-offers-admin') {
        <local-offers-dashboard
          [currentTab]="currentTab"
        ></local-offers-dashboard>
      }
    </mat-tab>
  }
  @if (tabs['homepage-admin']) {
    <mat-tab
      [label]="'homepage-admin'"
      class="homepage"
      >
      <ng-template mat-tab-label>Homepage Offers</ng-template>
      @if (currentTab.value == 'homepage-admin') {
        <homepage-dashboard
          [currentTab]="currentTab"
        ></homepage-dashboard>
      }
    </mat-tab>
  }
  @if (tabs['audit-admin']) {
    <mat-tab
      [label]="'audit-admin'"
      class="audit-admin"
      >
      <ng-template mat-tab-label>Audit Log</ng-template>
      @if (currentTab.value == 'audit-admin') {
        <delete-log-dashboard
          [currentTab]="currentTab"
        ></delete-log-dashboard>
      }
    </mat-tab>
  }
  @if (tabs['notification-admin']) {
    <mat-tab
      [label]="'notification-admin'"
      class="notification-admin"
      >
      <ng-template mat-tab-label>Notifications</ng-template>
      @if (currentTab.value == 'notification-admin') {
        <notification-dashboard
          [currentTab]="currentTab"
        ></notification-dashboard>
      }
    </mat-tab>
  }
</mat-tab-group>
